import Box from "@mui/material/Box";
import Hidden from "@mui/material/Hidden";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { flushSync } from "react-dom";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import InfoIcon from "../../images/icons/InfoIcon.svg";
import { TextNTooltip } from "../../components/Content";
import {
  BtnGroupStyle,
  ContentStyle,
  DataGridListStyle,
  DatePickerField,
  DRxInputStyle,
  DRxSelectStyle,
  HtmlTooltip,
  InputSMBoxStyle,
  TelephoneStyle,
} from "../../Theme";
import { YSButton } from "../../uikit/YSButton";
import { v4 as uuid } from "uuid";
import { ErrorMessage, Form, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import DRxInput from "../../uikit/DRxInput";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import DRxSelect from "../../uikit/DRxSelect";
import { useDispatch, useSelector } from "react-redux";
import Add from "@mui/icons-material/Add";
import Remove from "@mui/icons-material/Remove";
import useDebounce from "../../CustomHooks/useDebounce";
import { PatientSearchDetails } from "../../Apis/AuthApiServices";
import NoRecords from "../../components/NoRecords";
import ErrorOverlay from "../../components/ErrorOverlay";
import { useNavigate } from "react-router";
import YSSnackBar from "../../uikit/YSSnackBar";
import { clearPatientData } from "../../Redux/Slice/PatientDetailsSlice";
import { enableClinic } from "../../Redux/Slice/ClinicDisableSlice";
import { setPatientContext } from "../../utils/patientSession";
import { isAuthSessionStorageKey } from "../../utils/authCookie";
import {
  AGENTIC_RX_PATH,
  getRxExperienceEntryPath,
  getRxExperienceLabel,
} from "../../utils/AIPrescription/rxExperiencePreference";

export default function PatientSearch() {
  const [isPrinting, setIsPrinting] = useState(false);
  const dispatch = useDispatch();
  const phone2Ref = useRef<any>(null);
  const phone3Ref = useRef<any>(null);
  const navigate = useNavigate();
  const [advanceSearch, setAdvanceSearch] = useState(false);
  const [InputPatientSearchData, setInputPatientSearchData] = useState<any>({});
  const [error, setError] = useState(false);
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [patientId, setPatientId] = useState("");
  const [lastName, setLastName] = useState("");
  // const [guideTour, setGuideTour] = useState(false);
  const [validationData, setValidationData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const PrescriberDetailsState = useSelector((state: any) => {
    return { ...state?.PrescriberDetailsSlice?.AllPrescriberDetails };
  }); //redux data
  const AllDropdwonsState = useSelector((state: any) => {
    return { ...state.GlobalDropdownSlice.DropdownLists };
  }); //redux data
  const servicesData = useSelector((s: any) => s?.UserServicesSlice?.ServicesData);
  const patientIdDebounce = useDebounce(patientId, 1000);
  const lastNameDebounce = useDebounce(lastName, 1000);
  const rxExperiencePath = getRxExperienceEntryPath(servicesData);
  const rxExperienceLabel = getRxExperienceLabel(rxExperiencePath);
  const columnsPatientSearch: GridColDef[] = [
    {
      field: "hostPatientId",
      headerName: "Patient ID",
      minWidth: 100,
      cellClassName: "w10",
      headerClassName: "w10",
      renderCell: (params: any) => <TextNTooltip Text={params.value} />,
    },
    {
      field: "name",
      headerName: "Name",
      minWidth: 170,
      cellClassName: "w20",
      headerClassName: "w20",
    },
    {
      field: "dateOfBirth",
      headerName: "DOB",
      minWidth: 90,
      cellClassName: "w10",
      headerClassName: "w10",
    },
    {
      field: "address",
      headerName: "Address",
      minWidth: 250,
      cellClassName: "w35",
      headerClassName: "w35",
      renderCell: (params: any) => <TextNTooltip Text={params.value} />,
    },
    {
      field: "homeTelephone",
      headerName: "Telephone No.",
      minWidth: 130,
      cellClassName: "w12",
      headerClassName: "w12",
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      minWidth: 120,
      cellClassName: "w13",
      headerClassName: "w13",
      renderCell: ({ row }) => {
        return (
          <>
            <YSButton
              size={"small"}
              color="primary"
              className={""}
              children={rxExperienceLabel}
              onClick={() => {
                setPatientContext({
                  patientId: row?.personId,
                  hostPatientId: row?.hostPatientId,
                  patientName: row?.name,
                });
                navigate(rxExperiencePath, {
                  state:
                    rxExperiencePath === AGENTIC_RX_PATH
                      ? {
                          from: "comingFromPatientSearch",
                          patientName: row?.name,
                          personId: row?.personId,
                          hostPatientId: row?.hostPatientId,
                        }
                      : "comingFromPatientSearch",
                });
              }}
              variant={"contained"}
            />
          </>
        );
      },
    },
  ];

  const getPatientSearch = async (InputPatientSearchData: any) => {
    try {
      setLoading(true);
      const doctorId: any = localStorage.getItem("doctorId");
      const params = new URLSearchParams();
      params.append("doctorId", doctorId);
      params.append("pageNumber", `${page}`);
      const bodyData = {
        patientId: patientIdDebounce,
        lastName: lastNameDebounce,
        firstName: InputPatientSearchData?.firstName,
        gender:
          InputPatientSearchData?.Gender === "Select"
            ? ""
            : InputPatientSearchData?.Gender,
        dateOfBirth: InputPatientSearchData?.DateOfBirth,
        telHomeCode: InputPatientSearchData?.telephoneNo,
        telHomeNo1: InputPatientSearchData?.telephoneNo1,
        telHomeNo2: InputPatientSearchData?.telephoneNo2,
      };
      const result = await PatientSearchDetails(params, bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setData(result?.data?.response);
        setLoading(false);
        setError(false);
      } else {
        setData([]);
        setLoading(false);
        setError(false);
        setValidationData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err) {
      setData([]);
      setLoading(false);
      setError(true);
      setValidationData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const [rowCountState, setRowCountState] = useState(
    data[0]?.pagination?.totalItems || 0
  );
  useEffect(() => {
    function handleBeforePrint() {
      flushSync(() => {
        setIsPrinting(true);
      });
    }

    function handleAfterPrint() {
      setIsPrinting(false);
    }

    window.addEventListener("beforeprint", handleBeforePrint);
    window.addEventListener("afterprint", handleAfterPrint);
    return () => {
      window.removeEventListener("beforeprint", handleBeforePrint);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, []);
  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      data[0]?.pagination?.totalItems !== undefined
        ? data[0]?.pagination?.totalItems
        : prevRowCountState
    );
  }, [data[0]?.pagination?.totalItems, setRowCountState]);

  useEffect(() => {
    if (patientIdDebounce || lastNameDebounce) {
      getPatientSearch(InputPatientSearchData);
    }
  }, [page, patientIdDebounce, lastNameDebounce, InputPatientSearchData]);

  useEffect(() => {
    if (
      localStorage.getItem("Guide") == "true" &&
      PrescriberDetailsState?.idProofingRequired === false
    ) {
      localStorage.setItem("GuideON", "true");
      window.dispatchEvent(new Event("storage"));
    }
    window.dispatchEvent(new Event("storage"));
  }, [PrescriberDetailsState?.idProofingRequired]);

  let lastLogin = localStorage.getItem("LastLogin");
  useEffect(() => {
    dispatch(clearPatientData());
    dispatch(enableClinic());
    const keys = Object.keys(sessionStorage);
    keys.forEach((key) => {
      if (key !== "clinicId" && !isAuthSessionStorageKey(key)) {
        sessionStorage.removeItem(key);
      }
    });

    return () => {
      localStorage.removeItem("LastLogin");
    };
  }, []);
  return (
    <>
      <ContentStyle>
        <Formik
          initialValues={{
            telephoneNo: "",
            telephoneNo1: "",
            telephoneNo2: "",
            DateOfBirth: "",
            Gender: "Select",
            firstName: "",
          }}
          enableReinitialize
          onSubmit={(values) => {
            if (advanceSearch && (lastName !== "" || patientId !== "")) {
              setInputPatientSearchData(values);
            } else {
              setValidationData((prevState: any) => {
                return {
                  ...prevState,
                  message: "lastName or PatientId is required",
                  variant: "error",
                  open: true,
                };
              });
            }
          }}
        >
          {(formProps) => (
            <Form onSubmit={formProps.handleSubmit}>
              <Grid
                container
                xs={12}
                spacing={0}
                justifyContent="space-between"
                alignItems="top"
              >
                <Grid item xs={6}>
                  <Typography component="h6" color="primary" variant="h6">
                    Patient Search
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign={"right"}>
                  {!isPrinting && (
                    <Box
                      style={{
                        marginBottom: 10,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                    >
                      {" "}
                      <YSButton
                        onClick={() => {
                          if (advanceSearch) {
                            formProps.resetForm();
                            setInputPatientSearchData({});
                          }
                          setAdvanceSearch(!advanceSearch);
                        }}
                        startIcon={advanceSearch ? <Remove /> : <Add />}
                        className=""
                        id=""
                        children={"Advance Search"}
                        variant={"contained"}
                        size={"small"}
                      />
                      <Hidden mdDown>
                        {/* <GuideTourBtnStyle>
                        <YSButton
                          children="Tour"
                          variant="outlined"
                          type="button"
                          onClick={() => {
                            setGuideTour(!guideTour);
                          }}
                          size="small"
                          className={"guide-tour-btn"}
                        />
                      </GuideTourBtnStyle> */}
                      </Hidden>
                    </Box>
                  )}
                </Grid>
                {!isPrinting && (
                  <Grid container xs={12} md={12}>
                    {" "}
                    <Grid
                      container
                      item
                      xs={12}
                      spacing={0}
                      alignItems="top"
                      justifyContent="space-between"
                      columnSpacing={2}
                    >
                      {lastLogin && (
                        <Grid item xs={12} md={12}>
                          <Typography
                            color="primary"
                            variant="body2"
                            component="div"
                            marginBottom={2}
                          >
                            {lastLogin ?? ""}
                          </Typography>
                        </Grid>
                      )}
                      <Grid item xs={12} md={12}>
                        <Typography
                          color="error"
                          className="error"
                          variant="body2"
                          component="div"
                          marginLeft={10}
                        >
                          <ErrorMessage name="LastName" />
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <InputSMBoxStyle>
                          <Typography component="label" variant="body2">
                            Last Name
                            <Typography
                              color="error"
                              variant="body1"
                              component="span"
                            >
                              *
                            </Typography>
                          </Typography>{" "}
                          <Box>
                            {" "}
                            <TextField
                              id="lastName"
                              name="lastName"
                              onChange={(e: any) => {
                                setLastName(e.target.value);
                              }}
                              value={lastName}
                              autoFocus
                              variant="outlined"
                              placeholder="Enter Last Name"
                              style={{ borderRadius: 100 }}
                            />{" "}
                          </Box>
                        </InputSMBoxStyle>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <InputSMBoxStyle>
                          <Typography
                            component="label"
                            variant="body2"
                            htmlFor="lastname"
                            marginRight={3}
                          >
                            Patient Id
                            <HtmlTooltip
                              placement="top"
                              arrow
                              title={"Physician System's Patient Id"}
                            >
                              <IconButton className="tooltip">
                                <img
                                  src={InfoIcon}
                                  alt="Tooltip"
                                  loading="lazy"
                                />
                              </IconButton>
                            </HtmlTooltip>
                          </Typography>
                          <Box>
                            {" "}
                            <DRxInputStyle>
                              <TextField
                                name="patientId"
                                type="text"
                                onChange={(e: any) => {
                                  setPatientId(e.target.value);
                                }}
                                variant="outlined"
                                placeholder="Enter Patient Id"
                                value={patientId}
                              />
                            </DRxInputStyle>{" "}
                          </Box>
                        </InputSMBoxStyle>
                      </Grid>
                      {advanceSearch && (
                        <>
                          <Grid item xs={12} md={6}>
                            <InputSMBoxStyle>
                              <Typography
                                component="label"
                                variant="body2"
                                htmlFor="lastname"
                              >
                                First Name
                              </Typography>{" "}
                              <Box>
                                {" "}
                                <DRxInputStyle>
                                  <DRxInput
                                    type="text"
                                    placeholder="First Name"
                                    name="firstName"
                                  />
                                </DRxInputStyle>
                              </Box>
                            </InputSMBoxStyle>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <InputSMBoxStyle>
                              <Typography
                                component="label"
                                variant="body2"
                                htmlFor="dateofB"
                              >
                                Date of Birth
                              </Typography>
                              <Box>
                                <DatePickerField>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                  >
                                    <DatePicker
                                      label={"Date of Birth"}
                                      inputFormat="MM/dd/yyyy"
                                      value={
                                        formProps.values.DateOfBirth === ""
                                          ? null
                                          : formProps.values.DateOfBirth
                                      }
                                      onChange={(e) => {
                                        if (e === null) {
                                          formProps.setFieldValue(
                                            "DateOfBirth",
                                            ""
                                          );
                                        } else {
                                          formProps.setFieldValue(
                                            "DateOfBirth",
                                            moment(e).format("MM/DD/yyyy")
                                          );
                                        }
                                      }}
                                      renderInput={(params) => (
                                        <>
                                          <TextField
                                            {...params}
                                            name="DateOfBirth"
                                            error={
                                              formProps.touched.DateOfBirth &&
                                              Boolean(
                                                formProps.errors.DateOfBirth
                                              )
                                            }
                                          />
                                        </>
                                      )}
                                    />
                                  </LocalizationProvider>
                                </DatePickerField>
                              </Box>
                            </InputSMBoxStyle>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <InputSMBoxStyle>
                              {" "}
                              <Typography
                                component="label"
                                variant="body2"
                                htmlFor="gender"
                              >
                                Gender
                              </Typography>
                              <Box>
                                {" "}
                                <DRxSelectStyle>
                                  <DRxSelect
                                    name="Gender"
                                    id="gender"
                                    data={
                                      AllDropdwonsState?.genderOtions ?? [
                                        { label: "", value: "" },
                                      ]
                                    }
                                  />
                                </DRxSelectStyle>
                              </Box>
                            </InputSMBoxStyle>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <InputSMBoxStyle>
                              {" "}
                              <Typography component="label" variant="body2">
                                Telephone No
                              </Typography>{" "}
                              <Box>
                                {" "}
                                <TelephoneStyle>
                                  <DRxInput
                                    id="telephone"
                                    name="telephoneNo"
                                    type="number"
                                    className=""
                                    placeholder="Code"
                                    onChange={(event: any) => {
                                      formProps.setFieldValue(
                                        "telephoneNo",
                                        event.target.value.slice(0, 3)
                                      );
                                      if (event.target.value.length === 3) {
                                        phone2Ref?.current?.focus();
                                      }
                                    }}
                                  />{" "}
                                  <DRxInput
                                    id="telephone"
                                    name="telephoneNo1"
                                    type="number"
                                    className=""
                                    placeholder="NO1"
                                    inputRef={phone2Ref}
                                    onChange={(event: any) => {
                                      formProps.setFieldValue(
                                        "telephoneNo1",
                                        event.target.value.slice(0, 3)
                                      );
                                      if (event.target.value.length === 3) {
                                        phone3Ref?.current?.focus();
                                      }
                                    }}
                                  />
                                  <DRxInput
                                    id="telephone"
                                    name="telephoneNo2"
                                    type="number"
                                    className=""
                                    inputRef={phone3Ref}
                                    placeholder={"NO2"}
                                    onChange={(event: any) => {
                                      formProps.setFieldValue(
                                        "telephoneNo2",
                                        event.target.value.slice(0, 4)
                                      );
                                    }}
                                  />
                                </TelephoneStyle>
                              </Box>
                            </InputSMBoxStyle>
                          </Grid>
                          <Grid item xs={12} md={6}></Grid>
                          <Grid item xs={12} md={6}>
                            <BtnGroupStyle className="right">
                              <YSButton
                                size="large"
                                className=""
                                color="secondary"
                                dataTestId="submitBtn"
                                variant="outlined"
                                disabled={false}
                                type="reset"
                                children={"Reset"}
                                onClick={() => {
                                  setInputPatientSearchData({});
                                  formProps.resetForm();
                                  setPatientId("");
                                  setLastName("");
                                }}
                              />
                              <YSButton
                                size="large"
                                className=""
                                color="primary"
                                dataTestId="submitBtn"
                                variant="contained"
                                disabled={false}
                                type="submit"
                                children={"Search"}
                                onClick={null}
                              />
                            </BtnGroupStyle>
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </Grid>
                )}
              </Grid>{" "}
            </Form>
          )}
        </Formik>
        {/* {guideTour && (
          <UserGuide setGuideTour={setGuideTour} guideTour={guideTour} />
        )} */}
        <Grid
          container
          item
          xs={12}
          spacing={0}
          alignItems="top"
          justifyContent="center"
          marginTop={2}
        >
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                rows={data[0]?.items ?? []}
                sortingOrder={["desc", "asc"]}
                columns={columnsPatientSearch}
                autoHeight
                headerHeight={36}
                rowHeight={40}
                pageSize={pageSize}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                paginationMode="server"
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={error || undefined}
                getRowId={(row) => row.personId ?? uuid()}
                pagination
                loading={loading}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                page={page}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                rowCount={rowCountState}
              />
            </DataGridListStyle>
          </Grid>
        </Grid>
        <YSSnackBar
          message={validationData.message}
          variant={validationData.variant}
          open={validationData.open}
          handleClose={() => {
            setValidationData((prevState: any) => {
              return { ...prevState, open: false };
            });
          }}
        />
      </ContentStyle>
    </>
  );
}
